<h3 class="my-4 heading text-center">Welcome to NuvemRx 340B Recovery</h3>
<app-create-password-form [mode]="createPasswordModes.newUser" />
